/* ==========================================================================
   Sticker button press — minimum hold
   `:active` alone lasts exactly as long as the finger/mouse is down, so a quick
   tap seated the Add to cart button into its black backing for only a few
   milliseconds — too fast to read as a press. Mirror the state with an
   `.is-pressed` class that is held for at least MIN_PRESS_MS, then released.
   Purely visual: it never blocks or delays the click itself.
   ========================================================================== */
(function () {
  var MIN_PRESS_MS = 200;
  var SELECTOR = '.card--product .card__quick-add .btn-sticker .btn--primary';

  document.addEventListener(
    'pointerdown',
    function (event) {
      if (event.button && event.button !== 0) return; // primary button / touch only

      var btn = event.target.closest && event.target.closest(SELECTOR);
      if (!btn || btn.disabled) return;

      btn.classList.add('is-pressed');
      var pressedAt = Date.now();

      function release() {
        window.removeEventListener('pointerup', release, true);
        window.removeEventListener('pointercancel', release, true);
        var held = Date.now() - pressedAt;
        window.setTimeout(function () {
          btn.classList.remove('is-pressed');
        }, Math.max(0, MIN_PRESS_MS - held));
      }

      window.addEventListener('pointerup', release, true);
      window.addEventListener('pointercancel', release, true);
    },
    true
  );
})();
